<h1 mat-dialog-title>
  {{ title }}
</h1>

<div mat-dialog-content>
  <form class="flex flex-col gap-4 p-4">
    <mat-form-field class="w-full">
      <mat-label>
        {{ 'raw-data.fields.' + columnName | transloco }}
      </mat-label>
      <input type="number" matInput [formControl]="cellFormControl" />
    </mat-form-field>
    <dx-date-box
      type="datetime"
      [formControl]="timestampFormControl"
      placeholder="{{
        'raw-data.field.DATE' | transloco
      }}"
      [inputAttr]="{
        'aria-label': 'raw-data.field.DATE' | transloco,
      }"
    >
    </dx-date-box>
  </form>
</div>

<mat-dialog-actions align="end">
  <cc-action-button
    (onClick)="addCellData()"
    displayText="Add"
    [disabled]="!cellFormControl.valid"
  ></cc-action-button>
  <cc-cancel-action-button [mat-dialog-close]="true"></cc-cancel-action-button>
</mat-dialog-actions>
